import { ViewEventManagePage } from "./ViewEventManagePage";

export default ViewEventManagePage;
